import { VStack, HStack, Box, BoxProps } from '@chakra-ui/react'
import * as React from 'react'

import { IconSnsFacebook, IconSnsInstagram, IconSnsTwitter } from '../icons'
import { TextBodyBold1 } from '../common/Text';
import { vw } from '../../styles/theme'
import Link from '../common/Link'
import SVG from '../common/SVG'

export type NavSPSNSProps = BoxProps & {}

const NavSPSNS: React.FC<NavSPSNSProps> = ({ ...others }) => {
  return (
    <>
      <Box {...others}>
        <VStack>
          <Box mb={vw(50)}>
            <TextBodyBold1 localizeKey="nav__title__sns" color="text.200" />
          </Box>
          <HStack spacing={vw(80)}>
            <Link to="https://twitter.com/SenseIsland">
              <SVG svg={<IconSnsTwitter />} w={vw(72)} />
            </Link>
            <Link to="https://www.facebook.com/Sense-Island-109572490384999/">
              <SVG svg={<IconSnsFacebook />} w={vw(60)} />
            </Link>
            <Link to="https://www.instagram.com/senseisland_sarushima/">
              <SVG svg={<IconSnsInstagram />} w={vw(60)} />
            </Link>
          </HStack>
        </VStack>
      </Box>
    </>
  )
}

export default NavSPSNS
